/**
 * The fields that a softwareDevelopmentKit can be ordered on
 */
export enum SoftwareDevelopmentKitOrderField {
  /** The name of the softwareDevelopmentKit */
  Name = 'name',
  /** The age of the softwareDevelopmentKit */
  CreatedAt = 'createdAt',
  /** The last updated time */
  UpdatedAt = 'updatedAt',
}
